import { LegacySalesPlatform } from "components/organisms/LegacySalesPlatformIFrame";

const RetailAdmin = () => {
  return <LegacySalesPlatform page="retailAdmin" />;
};

export { RetailAdmin };
